import React from 'react';
import { formatSparks } from '../../api/sparksApi';
import useCountUp from '../../hooks/useCountUp';
import './sparks.css';

/**
 * A Sparks number that counts up to `value`. Its digits are all one width and it keeps the width of `reserve`
 * (default `value`, the number it is heading for), so a count-up never nudges the text around it or a centred line
 * from side to side.
 */
export default function SparksCount({ value, reserve = value, duration }) {
  const shown = useCountUp(value, duration);
  return (
    <span className="sparks-count" data-reserve={formatSparks(Math.max(shown, reserve))}>
      <span>{formatSparks(shown)}</span>
    </span>
  );
}
